"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * CardScan API
 * The official documentation for the CardScan API Clients.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CardState = void 0;
/**
 *
 * @export
 * @enum {string}
 */
exports.CardState = {
    Pending: 'pending',
    Processing: 'processing',
    FrontsideProcessing: 'frontside_processing',
    FrontsideFailed: 'frontside_failed',
    BacksideProcessing: 'backside_processing',
    BacksideFailed: 'backside_failed',
    PostProcessing: 'post_processing',
    Completed: 'completed',
    Enriched: 'enriched',
    Error: 'error',
    Unknown: 'unknown'
};
